import { useQuery } from "react-query";

import { WebTrackerPublishedBlockerConfigResponse } from "../types";
import { makeRequest } from "../../util";
import { envLocker } from "../../reducers/environments";

export default function useFetchPublishedTrackerBlockerConfig() {
  return useQuery<WebTrackerPublishedBlockerConfigResponse | null>(
    ["getPublishedTrackerBlockerConfig", envLocker.getEnvID()],
    async () => {
      const res = await makeRequest<WebTrackerPublishedBlockerConfigResponse>(
        "get_published_tracker_blocker_config",
        undefined,
        {
          validateStatus: (status) => status === 200 || status === 404,
        }
      );

      if (res.status === 404) {
        return null;
      }

      return res.data;
    }
  );
}
